import { render, staticRenderFns } from "./BuyBoxQualityTVNew.vue?vue&type=template&id=3613f304&scoped=true"
import script from "./BuyBoxQualityTVNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxQualityTVNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxQualityTVNew.vue?vue&type=style&index=0&id=3613f304&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3613f304",
  null
  
)

export default component.exports